import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';

/**
 * EmptyState - Centered empty state matching Figma design
 */
export function EmptyState({ 
  icon = faClipboardList, 
  title = 'No hay servicios activos', 
  subtitle = 'Cuando tengas solicitudes o tareas asignadas aparecerán aquí.', 
  actionLabel, 
  onAction 
}) {
  return (
    <div 
      className="bry-empty-state text-center p-4 my-3" 
      style={{ 
        background: 'var(--bry-bg-card, rgba(14, 171, 176, 0.04))', 
        borderRadius: '16px', 
        border: '1px dashed var(--bry-border-default, #cbd5e1)' 
      }}
    >
      {/* Icon Circle Container */}
      <div 
        style={{ 
          width: 48, 
          height: 48, 
          borderRadius: '50%', 
          background: 'var(--bry-accent-subtle, rgba(14, 171, 176, 0.12))', 
          color: 'var(--bry-accent, #0EABB0)', 
          display: 'inline-flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          marginBottom: 12 
        }}
      >
        <FontAwesomeIcon icon={icon} size="lg" />
      </div>

      <h5 style={{ fontSize: '0.95rem', fontWeight: 700, color: 'var(--bry-text-primary, #0f172a)', marginBottom: 4 }}>
        {title}
      </h5>
      <p style={{ fontSize: '0.8rem', color: 'var(--bry-text-secondary, #64748b)', margin: 0 }}>
        {subtitle}
      </p>

      {actionLabel && (
        <button
          onClick={onAction}
          className="bry-btn bry-btn-primary mt-3"
          style={{ padding: '6px 16px', fontSize: '0.8rem' }}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export default EmptyState;
